import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { roleHome } from "../../../utils/roleHome";

export function ProtectedRoute({ children, allow }) {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.ready) return <main className="site-shell" style={{ paddingTop: 140 }}>Loading account…</main>;
  if (!auth.isAuthenticated) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (allow && !allow.includes(auth.user?.role)) return <Navigate to={roleHome(auth.user?.role)} replace />;
  return children;
}
